module.exports = __webpack_public_path__ + "img/blue.1ba09a89.jpg";